import useSWR, { SWRResponse } from "swr";
import { MessageTemplate } from "../types";

interface useMessageTemplatesReturn extends SWRResponse<MessageTemplate[], any> {
    isLoading: boolean;
    templates: MessageTemplate[];
}

export const useMessageTemplates = (clubSlug: string): useMessageTemplatesReturn => {
    const { data, error, ...swr } = useSWR(`message-management/template/${clubSlug}/all`);

    return {
        isLoading: !data && !error,
        templates: data?.data || [],
        data,
        error,
        ...swr,
    };
};
